import { interfaceMiddlewares } from './interface/interface.middleware';
import { rulesMiddleware } from './rules/rules.middleware';
import { filtersMiddleware } from './filters/filters.middleware';

export const campaignsFilterMiddlewares = [
    interfaceMiddlewares,
    rulesMiddleware,
    filtersMiddleware,
];
